import script from "./ShipmentListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ShipmentListView.vue?vue&type=script&setup=true&lang=js"

import "./ShipmentListView.vue?vue&type=style&index=0&id=c4f7f658&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c4f7f658"]])

export default __exports__